import styled from 'styled-components'

import {Container} from '~/components/general/container/Container'

export const QuestionContainer = styled(Container)`
  padding: 8px 0;
`

export const ChoiceGroupBorder = styled(Container)<{required?: boolean}>`
  width: 100%;
  background-color: ${({theme}) => theme.colors.white};
  border: 1px solid
    ${({theme, required}) =>
      required ? theme.colors.inputBorderRequired : theme.colors.inputBorder};
  border-radius: ${({theme}) => theme.borderRadius.xs};
  padding: ${({theme}) => theme.spacing.sm};
`

export const RadioOptionRow = styled(Container).attrs({
  align: 'center',
})``

export const RadioInput = styled.input.attrs({type: 'radio'})`
  width: 16px;
  height: 16px;
  cursor: pointer;
  margin-right: 8px;
`

export const RadioLabel = styled.label`
  cursor: pointer;
  user-select: none;
`

export const BoldRedText = styled.strong`
  font-weight: bold;
  color: ${({theme}) => theme.colors.red};
`
